import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.i5x_1 = delegate;
        this.j5x_1 = call;
      }
      *s5b(frame, $completion) {
        yield* this.i5x_1.s5b(frame, $completion);
        return Unit_instance;
      }
      *f4k($completion) {
        yield* this.i5x_1.f4k($completion);
        return Unit_instance;
      }
      o5b(_set____db54di) {
        this.i5x_1.o5b(_set____db54di);
      }
      p5b() {
        return this.i5x_1.p5b();
      }
      q5b() {
        return this.i5x_1.q5b();
      }
      r5b() {
        return this.i5x_1.r5b();
      }
      dw() {
        return this.i5x_1.dw();
      }
      n5b(negotiatedExtensions) {
        this.i5x_1.n5b(negotiatedExtensions);
      }
      m5b() {
        return this.i5x_1.m5b();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.k5x_1 = session;
        this.l5x_1 = call;
      }
      *s5b(frame, $completion) {
        yield* this.k5x_1.s5b(frame, $completion);
        return Unit_instance;
      }
      *f4k($completion) {
        yield* this.k5x_1.f4k($completion);
        return Unit_instance;
      }
      o5b(_set____db54di) {
        this.k5x_1.o5b(_set____db54di);
      }
      p5b() {
        return this.k5x_1.p5b();
      }
      q5b() {
        return this.k5x_1.q5b();
      }
      r5b() {
        return this.k5x_1.r5b();
      }
      dw() {
        return this.k5x_1.dw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
